import { handleActions } from "redux-actions";
import { PROFILE_INFO_REQUEST, PROFILE_INFO_SUCCESS } from "./types";

const initState = {
  profileData: null,
};

export default handleActions(
  {
    [PROFILE_INFO_REQUEST]: (state) => ({ ...state, profileData: null }),
    [PROFILE_INFO_SUCCESS]: (state, { payload }) => {
      return { 
        ...state,
        profileData: { 
          ...payload,
          unit_system: payload?.unit_system?.toLowerCase(), 
        }
      };
    },
  },
  initState
);
